<template lang="pug">
  .mapYearTrack
    .year-track(
      v-if="yearList && yearList.length > 1"
    )
      span.year-track__title Дата: {{year}}
      .year-track__wrapper
        span.year-track__start {{min}}
        .year-track__path
          el-slider(
            style="width:100%;"
            :min="min"
            :max="max"
            v-model="year"
            @change="$emit('map-update', year)"
            :step="1"
            show-stops
          )
        span.year-track__end {{max}}
</template>
<script>
import { map as mapEndpoints } from '@/api/api-endpoints'
import year from '@/utils/year'
import currentYear from '@/utils/year'

export default {
  props: {
    mapType: {
      type: String,
      required: true,
    },
    route: Object,
    dataUrl: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    year: 0,
    yearList: [],
    min: null,
    max: null,
  }),
  methods: {
    getYearListEndpoint() {
      return this.dataUrl || mapEndpoints.yearListForWasteGeoObjects()
    },
    yearHandler(year) {
      this.replaceRoute({ year }, false)
    },
    async getYears() {
      const data = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getYearListEndpoint(),
        })
      ).data.year
      // выставляем нужный год в самом начале ...
      if (!this.year && data.length > 0) {
        this.year = +this.route?.query?.year || year.getCurrentYear()
      }
      this.yearList = data
        .sort((a, b) => +a.year - +b.year)
        .map((i) => +i.year || +i)

      this.min = this.yearList[0]
      this.max =
        this.yearList[this.yearList.length - 1] || currentYear.getCurrentYear()
    },
  },
  created() {
    this.getYears()
  },
}
</script>
